export default __webpack_public_path__ + "static/media/fitShapeMb.62f60b45.png";